export const validation = {
	title_es: 'required|min:3|max:255',
	content_es: 'min:1',
	excerpt_es: 'min:1',
	tags_es: 'min:1',
	title_en: 'required|min:3|max:255',
	content_en: 'min:1',
	excerpt_en: 'min:1',
	tags_en: 'min:1',
	status_id: 'required|numeric|min_value:1|max:2',
	title_fr: 'required|min:3|max:255',
	content_fr: 'min:1',
	excerpt_fr: 'min:1',
	tags_fr: 'min:1',
	title_pt: 'required|min:3|max:255',
	content_pt: 'min:1',
	excerpt_pt: 'min:1',
	tags_pt: 'min:1',
	title_it: 'required|min:3|max:255',
	content_it: 'min:1',
	excerpt_it: 'min:1',
	tags_it: 'min:1',
	title_de: 'required|min:3|max:255',
	content_de: 'min:1',
	excerpt_de: 'min:1',
	tags_de: 'min:1'
}

export const Fields = function() {
	return {
		title_es: null,
		excerpt_es: null,
		tags_es: null,
		content_es: null,
		title_en: null,
		excerpt_en: null,
		tags_en: null,
		content_en: null,
		cover: null,
		status_id: null,
		title_fr: null,
		excerpt_fr: null,
		tags_fr: null,
		content_fr: null,
		title_it: null,
		excerpt_it: null,
		tags_it: null,
		content_it: null,
		title_pt: null,
		excerpt_pt: null,
		tags_pt: null,
		content_pt: null,
		title_de: null,
		excerpt_de: null,
		tags_de: null,
		content_de: null
	}
}

export const StatusList = [
	{
		id: 1,
		name: 'Activo'
	},
	{
		id: 2,
		name: 'Inactivo'
	}
]

export const texts = {
	pageEdit: {
		title: 'Editar Página Existente',
		subtitle: 'Edita la información de la Página.',
		submit: 'Actualizar Entrada',
		messages: {
			success: {
				title: 'PÁGINA ACTUALIZADA',
				text: 'Esta Página ha sido actualizada correctamente'
			}
		}
	},
	pageNew: {
		title: 'Añadir Nueva Página',
		subtitle: 'Crear nueva Página',
		submit: 'Crear Página',
		messages: {
			success: {
				title: 'PÁGINA CREADA',
				text: 'Se ha creado correctamente la neva Página'
			}
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/pages/moks.js